import React from 'react';
import { Modal, Button, Badge, Card, Row, Col, Table } from 'react-bootstrap';

const CommandeDetailsModal = ({ show, handleClose, commande }) => {
    if (!commande) return null;

    const promoCode =
        commande.promo?.code ||
        commande.code_promo_utilise ||
        '-';

    const promoReduction =
        commande.promo?.remise ||
        commande.promo_remise ||
        0;

    const paymentBadgeVariant = (() => {
        const statut = (commande.statut_paiement || '').toLowerCase();

        if (
            statut.includes('paid') ||
            statut.includes('payé') ||
            statut.includes('réussi') ||
            statut.includes('succeeded')
        ) {
            return 'success';
        }

        if (
            statut.includes('en attente') ||
            statut.includes('processing') ||
            statut.includes('requires_capture') ||
            statut.includes('pending')
        ) {
            return 'warning';
        }

        if (
            statut.includes('annulé') ||
            statut.includes('cancel') ||
            statut.includes('failed') ||
            statut.includes('échoué')
        ) {
            return 'danger';
        }

        return 'secondary';
    })();
    const getStatutPaiementFR = (status) => {
  switch (status) {
    case 'requires_payment_method':
      return 'Paiement échoué';
    case 'requires_confirmation':
      return 'À confirmer';
    case 'requires_action':
      return 'Action requise';
    case 'processing':
      return 'En cours de traitement';
    case 'requires_capture':
      return 'Non capturé';
    case 'succeeded':
      return 'Réussi';
    case 'canceled':
      return 'Annulé';
    default:
      return status || 'Inconnu';
  }
};

    const commandeBadgeVariant = (() => {
        const statut = (commande.statut_commande || '').toLowerCase();

        if (
            statut.includes('livré') ||
            statut.includes('terminé') ||
            statut.includes('validé')
        ) {
            return 'success';
        }

        if (
            statut.includes('attente') ||
            statut.includes('cours')
        ) {
            return 'warning';
        }

        if (
            statut.includes('annulé') ||
            statut.includes('refusé')
        ) {
            return 'danger';
        }

        return 'primary';
    })();

    return (
        <Modal show={show} onHide={handleClose} size="xl" centered>
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold">
                    Commande #{commande.id}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="pt-3">
                <div className="container-fluid">
                    <Row className="g-3">
                        <Col md={8}>
                            <Card className="shadow-sm border-0 mb-3">
                                <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                                        <h5 className="mb-2 mb-md-0 org-clr fw-bold">
                                            Détails de la commande
                                        </h5>

                                        <div className="d-flex gap-2 flex-wrap">
                                            <Badge bg={paymentBadgeVariant} className="px-3 py-2">
                                                Paiement : {getStatutPaiementFR(commande.statut_paiement) || '-'}
                                            </Badge>
                                            <Badge bg={commandeBadgeVariant} className="px-3 py-2">
                                                Commande : {commande.statut_commande || '-'}
                                            </Badge>
                                        </div>
                                    </div>

                                    <Row className="mb-3">
                                        <Col sm={6}>
                                            <div className="p-3 bg-light rounded">
                                                <small className="text-muted d-block">Date de commande</small>
                                                <strong>{commande.date_commande || '-'}</strong>
                                            </div>
                                        </Col>
                                        <Col sm={6}>
                                            <div className="p-3 bg-light rounded">
                                                <small className="text-muted d-block">Date de service</small>
                                                <strong>{commande.date_service || '-'}</strong>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col sm={6}>
                                            <div className="p-3 border rounded h-100">
                                                <small className="text-muted d-block mb-1">Code promo</small>
                                                <strong>{promoCode}</strong>
                                            </div>
                                        </Col>
                                        <Col sm={6}>
                                            <div className="p-3 border rounded h-100">
                                                <small className="text-muted d-block mb-1">Réduction appliquée</small>
                                                <strong>{promoReduction}€</strong>
                                            </div>
                                        </Col>
                                    </Row>

                                    <div className="table-responsive">
                                        <Table hover bordered className="align-middle mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Article</th>
                                                    <th>Quantité</th>
                                                    <th>Addons</th>
                                                    <th>Instructions</th>
                                                    <th>Prix unitaire</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {commande.plats?.map((plat, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <strong>{plat.nom}</strong>
                                                        </td>
                                                        <td>{plat.quantite}</td>
                                                        <td>
                                                            {plat.addons && plat.addons.length > 0 ? (
                                                                plat.addons.map((addon, addonIndex) => (
                                                                    <div key={addonIndex} className="mb-2">
                                                                        <strong>{addon.nom}</strong>
                                                                        {addon.modules && addon.modules.length > 0 ? (
                                                                            addon.modules.map((module, modIndex) => (
                                                                                <div key={modIndex} className="small text-muted">
                                                                                    - {module.nom}
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <div className="small text-muted">- Aucun module</div>
                                                                        )}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <span className="text-muted">Aucun</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {plat.instructions ? (
                                                                plat.instructions
                                                            ) : (
                                                                <span className="text-muted">Aucune</span>
                                                            )}
                                                        </td>
                                                        <td>{plat.prix}€</td>
                                                        <td className="fw-bold">{plat.total}€</td>
                                                    </tr>
                                                ))}

                                                <tr className="table-light">
                                                    <td colSpan="5" className="text-end fw-bold">
                                                        Montant payé
                                                    </td>
                                                    <td className="fw-bold">
                                                        {commande.montant}€
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4}>
                            <Card className="shadow-sm border-0 h-100">
                                <Card.Body>
                                    <h5 className="org-clr fw-bold mb-3">
                                        Détails du client
                                    </h5>

                                    <div className="mb-3 p-3 bg-light rounded">
                                        <small className="text-muted d-block">Prénom</small>
                                        <strong>{commande.prenom || '-'}</strong>
                                    </div>

                                    <div className="mb-3 p-3 bg-light rounded">
                                        <small className="text-muted d-block">Nom</small>
                                        <strong>{commande.nom || '-'}</strong>
                                    </div>

                                    <div className="mb-3 p-3 bg-light rounded">
                                        <small className="text-muted d-block">Téléphone</small>
                                        <strong>{commande.tele || '-'}</strong>
                                    </div>

                                    <div className="mb-3 p-3 bg-light rounded">
                                        <small className="text-muted d-block">Email</small>
                                        <strong>{commande.email || '-'}</strong>
                                    </div>

                                    <div className="p-3 bg-light rounded">
                                        <small className="text-muted d-block">Adresse</small>
                                        <strong>{commande.adresse || '-'}</strong>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>

            <Modal.Footer className="border-0 pt-0">
                <Button variant="secondary" onClick={handleClose}>
                    Fermer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CommandeDetailsModal;